// removed by extract-text-webpack-plugin
module.exports = {"variables":"\"../../../assets/stylesheets/variables.css\"","borderGrey":"#d5dfdf","customBlack":"#000000","mainImageContainer":"_3LNl3SGB1sML4svjJKtlOA","mainImage":"_2N75qp_BEKSIzSudE1Cegk","chevronContainer":"_1rRyJ17ua2sw7ESS-A7Te","imageListContainer":"_1H7TxupN4-PbRG9nmYAqYB","imageListWrapper":"_3fbTgCQaN9L50QSvDiQ_lL","imageBox":"_3NpHanAnht8EWo6b1W0Hjg","selected":"_1fEHo4KH1XxfL6SDewfAw","imageFlex":"_2pLz-GWyM2SdBs2Iz1iCDu"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/product-detail/image-carousel/ImageCarousel.css
// module id = 1001
// module chunks = 1